export default function addEventListener(node, eventName, handler, options) {
    node.addEventListener(eventName, handler, options);
    return {
        removeEventListener: function removeEventListener() {
            node.removeEventListener(eventName, handler, options);
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-cursor-position/dist/es/utils/addEventListener.js
// module id = 102
// module chunks = 0